<template>
  <div>
    <loading
      v-if="loading"
      message="Загружаем информацию..."/>
    <loading
      v-else-if="saving"
      message="Сохраняем информацию..."/>
    <div
      v-else
      class="row">
      <div class="col-12 col-sm-12 col-md-10 col-lg-8">
        <admin-card>
          <admin-form-multi-select
            v-model="newDataItem.entityType"
            :options="entityTypeOptions"
            :label-text="'Тип сущности к которой относится'"
            :error="$v.newDataItem.entityType.$error"
            :error-text="'Тип обязательно должн быть указан'"
            @input="$v.newDataItem.entityType.$touch()"/>
          <admin-form-input
            v-model="newDataItem.name"
            :label-text="'Название'"
            :label-id="'inputName'"
            :input-require="true"
            :error="$v.newDataItem.name.$error"
            :error-text="'Название обязательно должно быть указано, минимум 2 символа'"
            @input="$v.newDataItem.name.$touch()"/>
          <admin-form-multi-select
            v-model="newDataItem.type"
            :options="typeOptions"
            :label-text="'Тип поля'"
            :error="$v.newDataItem.type.$error"
            :error-text="'Тип обязательно должн быть указан'"
            @input="$v.newDataItem.type.$touch()"/>
          <admin-form-input
            v-model="newDataItem.code"
            :label-text="'Код (разделяя точкой группы)'"
            :label-id="'inputCode'"
            :input-require="true"
            :error="$v.newDataItem.code.$error"
            :error-text="'Код обязательно должн быть указан, минимум 2 символа'"
            @input="$v.newDataItem.code.$touch()"/>
          <admin-form-input
            v-model="newDataItem.amoId"
            :label-text="'Идентификатор поля в AmoCrm'"
            :label-id="'inputAmoId'"
            :input-require="false"
            :error="$v.newDataItem.amoId.$error"
            :error-text="'Идентификатор должен состоять из цифр'"
            @input="$v.newDataItem.amoId.$touch()"/>
          <admin-form-input
            v-model="newDataItem.sort"
            :label-text="'Сортировка поля в карточке'"
            :label-id="'inputSort'"
            :input-require="false"
            :error="$v.newDataItem.sort.$error"
            :error-text="'Допустимо только число'"
            @input="$v.newDataItem.sort.$touch()"/>
          <admin-form-check-box
            v-model="newDataItem.required"
            :label-text="'Обязательно для заполнения при редактировании'"
          />
          <admin-form-check-box
            v-model="newDataItem.viewed"
            :label-text="'Значение сможет видеть любой пользователь, который имеет доступ к просмотру сущности'"
          />
          <admin-form-check-box
            v-model="newDataItem.editable"
            :label-text="'Значение сможет редактировать любой пользователь, который имеет доступ к редактированию сущности'"
          />
          <template slot="footer">
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click.prevent="beforeUpdateForm">
              <template v-if="newDataItem.id">Сохранить изменения</template>
              <template v-else>Добавить кастомное поле</template>
            </button>
          </template>
        </admin-card>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminCard from '../Components/AdminCard'
  import { required, minLength, numeric } from 'vuelidate/lib/validators'
  import AdminFormInput from './../Components/AdminFormComponents/AdminFormInput'
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getCustomFieldByIdQuery from 'gql/queries/getCustomFieldById.graphql'
  import AdminFormMultiSelect
    from '../Components/AdminFormComponents/AdminFormMultiSelect'
  import AdminFormCheckBox
    from '../Components/AdminFormComponents/AdminFormCheckBox'
  import AddCustomFieldMutation from 'gql/mutations/AddCustomField.graphql'
  import UpdateCustomFieldMutation from 'gql/mutations/UpdateCustomField.graphql'
  export default {
    name: 'CFEdit',
    components: {
      AdminFormCheckBox,
      AdminFormMultiSelect,
      AdminCard,
      AdminFormInput
    },
    watch: {
      'item.customFields' () {
        this.newDataItem = Object.assign({}, this.item.customFields[0])
      }
    },
    data () {
      return {
        loading: false,
        saving: false,
        newDataItem: {
          id: null,
          name: null,
          entityType: null,
          code: null,
          type: null,
          sort: null,
          required: false,
          viewed: false,
          editable: false
        },
        entityTypeOptions: [
          {
            name: 'Техцентр',
            value: 'techcenter'
          },
          {
            name: 'Заказ',
            value: 'order'
          },
          {
            name: 'Компания',
            value: 'company'
          }
        ],
        typeOptions: [
          {
            name: 'Флаг',
            value: 'checkbox'
          },
          {
            name: 'Число',
            value: 'number'
          },
          {
            name: 'Текст',
            value: 'text'
          },
          {
            name: 'Текстовая область',
            value: 'textarea'
          }
        ]
      }
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        code: {
          required,
          minLength: minLength(2)
        },
        entityType: {
          required
        },
        type: {
          required
        },
        amoId: {
          numeric
        },
        sort: {
          numeric
        }
      }
    },
    methods: {
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.$route.params.id) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.saving = true
        this.$apollo.mutate({
          mutation: AddCustomFieldMutation,
          variables: this.newDataItem
        }).then((result) => {
          this.saving = false
          this.addToast({
            text: 'Кастомное поле успешно добавлено',
            type: 'success',
            dismissAfter: 3000
          })
          this.$router.push({ name: 'CustomFieldsEdit', params: { id: result.data.addCustomField.id } })
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Прооизошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.saving = false
        })
      },
      updateItem () {
        this.saving = true
        this.$apollo.mutate({
          mutation: UpdateCustomFieldMutation,
          variables: this.newDataItem
        }).then((result) => {
          this.saving = false
          this.addToast({
            text: 'Кастомное поле успешно обновлено',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.addToast({
            text: 'Прооизошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.saving = false
        })
      },
      clearData () {
        this.newDataItem = {
          id: null,
          name: null,
          entityType: null,
          code: null,
          type: null,
          sort: null,
          required: false,
          viewed: false,
          editable: false
        }
        this.$v.newDataItem.$reset()
      },
      loadData () {
        this.$apollo.queries.item.skip = false
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      item: {
        skip: true,
        query: getCustomFieldByIdQuery,
        variables () {
          return {
            id: this.$route.params.id
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    },
    created () {
      if (this.$route.params.id) {
        this.loadData()
      } else {
        this.clearData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CFEdit.vue?03e08592